import {User} from 'domain-models'

export interface UpdateUser {
  type: 'UPDATE_USER'
  user: User | null
}

export const updateUser: (user: User | null) => UpdateUser = user => ({
  type: 'UPDATE_USER',
  user,
})
